export function fetch(idSeason) { return { type: 'ENTRIES/FETCH', idSeason } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/entries.js